<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('users')">Usuários</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Atualizar
      </h1>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.setor" :error="form.errors.setor" class="pr-6 pb-8 w-full lg:w-1/2" label="Setor">
            <option value="D">Desenvolvimento</option>
            <option value="C">Comercial</option>
            <option value="I">Implantação</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Atualizar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo() {
    return {
      title: `${this.user.login}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
  },
  layout: Layout,
  props: {
    user: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        setor: null,
      }),
    }
  },
  created(){
    this.form.setor = this.user.tipo?.tipo
  },
  methods: {
    update() {
      this.form.post(this.route('users.update', this.user.id_usuario))
    },
  },
}
</script>
